import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaDoorOpen, FaCog, FaUserShield } from 'react-icons/fa';
import { getAuth, signOut } from 'firebase/auth';
import { useFireAuth } from '../FireAuthContext';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../App';
import './Header.css';

const Header = () => {
  const auth = getAuth();
  const navigate = useNavigate();
  const { user, updateUser } = useFireAuth();
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const checkAdminStatus = async () => {
      if (user && user.uid) {
        const adminDocRef = doc(db, 'admins', user.uid);
        const adminDocSnap = await getDoc(adminDocRef);
        setIsAdmin(adminDocSnap.exists());
      }
    };

    checkAdminStatus();
  }, [user]);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      console.log('User signed out');
      await updateUser();
      navigate('/login');
    } catch (error) {
      console.error('Error signing out:', error.message);
    }
  };

  return (
    <header className="portal-header">
      <div className="header-left">
        <Link to="/portal/settings" className="icon-button">
          <FaCog className="header-icon" />
        </Link>
        {isAdmin && (
          <Link to="/portal/admin" className="icon-button">
            <FaUserShield className="header-icon" />
          </Link>
        )}
      </div>
      <h1 className="header-title">Hahum</h1>
      <div className="header-right">
        <button onClick={handleLogout} className="icon-button">
          <FaDoorOpen className="header-icon" />
        </button>
      </div>
    </header>
  );
};

export default Header;